(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("paymentMethodPurchaseOrder", {
        templateUrl: "app/settings/storefront/paymentMethod/paymentMethodPurchaseOrder.component.html",
        controller: ["tenantPaymentMethodResource", "messageService", "$state", PaymentMethodPurchaseOrderCtrl],
        controllerAs: "vm"
    });
    function PaymentMethodPurchaseOrderCtrl(tenantPaymentMethodResource, messageService, $state) {
        var vm = this;
        //vm.model = {};
        vm.isConfigured = $state.params.isConfigured;
        vm.id = $state.params.id;
        vm.save = function () {
            if (vm.isConfigured) {
                activate();
            }
            else {
                deactivate();
            }
        };
        function activate() {
            vm.saving = true;
            tenantPaymentMethodResource.activate({ id: vm.id }, function () {
                vm.saving = false;
                vm.form.$setPristine();
                messageService.success("common.changesSaved");
            }, function (error) {
                console.error(error);
                messageService.error("common.genericError");
                vm.saving = false;
            });
        }
        function deactivate() {
            vm.saving = true;
            tenantPaymentMethodResource.deactivate({ id: vm.id }, function () {
                vm.saving = false;
                vm.form.$setPristine();
                messageService.success("common.changesSaved");
            }, function (error) {
                console.error(error);
                messageService.error("common.genericError");
                vm.saving = false;
            });
        }
    }
})();
